import { render } from "./slide18.vue?vue&type=template&id=10c9333a&scoped=true"
import script from "./slide18.vue?vue&type=script&lang=js"
export * from "./slide18.vue?vue&type=script&lang=js"

import "./slide18.vue?vue&type=style&index=0&id=10c9333a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c9333a"]])

export default __exports__